import Service from '../Service'
import {http} from '../config'

export default class UsuarioService extends Service{

    constructor(){
        super('usuario');
    }

    async AlterarSenha(id, senhaAntiga, senhaNova){

        const senhas = {
            usuarioId: id,
            senhaAntiga: senhaAntiga,
            senhaNova: senhaNova
        };
        
        return await http.post(this._nomeControle + "/AlterarSenha", senhas);
    }

    AutoComplete(q) {
        return http.get(this._nomeControle + "/AutoComplete?q=" + q);
    }

    RelatorioLog(dataInicio, dataFim, usuarioId, operacao, ordenacao){
        return http.get(`${this._nomeControle}/relatorioLog`, {
            params: {
                dataInicio: dataInicio,
                dataFim: dataFim, 
                usuarioId: usuarioId,
                operacao: operacao,
                ordenacao: ordenacao
            }
        })
    }   

    ResetarSenha(cnpj, login){

        const model = {
            cnpj: cnpj,
            login: login
        }

        return http.post(`${this.getNomeControle()}/redefinirsenha`, model);
    }  

    MudarTema(id){ 
        return http.put(`${this._nomeControle}/${id}/MudarTema`, null);
    }
}